import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
var isEmpty = function isEmpty(obj) {
  var _context;
  return _includesInstanceProperty(_context = [Object, Array]).call(_context, (obj || {}).constructor) && !_Object$entries(obj || {}).length;
};
export default isEmpty;